// Helpers for the customer cart's selected slots (service_obj, persisted in localStorage).
// JOYWEB-3135: the persisted cart has no expiry, so a slot picked days ago could be
// submitted (and paid for) after it had passed. These helpers drop expired slots so the
// customer re-picks a time; the server (add_bookings_v2 / customer reschedule) enforces
// the same rule. JOYWEB-3136: availability results are matched to cart rows by identity.
import moment from 'moment';
import 'moment-timezone';

const STORE_TIMEZONE = 'Australia/Brisbane';
const SLOT_FIELDS = ['slot_start_time', 'slot_end_time', 'slot_date', 'staff_id', 'staff_name'];
const EXPIRED_NOTICE_KEY = 'slot_expired_notice';

function slot_start(serv) {
    return moment.tz(serv.slot_date + ' ' + serv.slot_start_time, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true, STORE_TIMEZONE);
}

function is_expired(serv, now) {
    if (!serv || !serv.slot_date || !serv.slot_start_time) return false;
    let start = slot_start(serv);
    return start.isValid() && !start.isAfter(now || moment());
}

function matches_any(serv, slots) {
    return slots.some(s => s.start_date == serv.slot_date && s.start_time == serv.slot_start_time);
}

function clear_slot(serv) {
    SLOT_FIELDS.forEach(field => { delete serv[field]; });
}

export default {
    EXPIRED_NOTICE_KEY,

    // Clears expired slots (plus any slot the server reported as past) from the persisted
    // cart. Returns the number cleared; when > 0 the session cart is rewritten and a notice
    // flag is set for the cart page to show.
    clear_expired_slots(session, server_past_slots) {
        if (!session.get('service_obj')) return 0;
        let services = JSON.parse(session.get('service_obj'));
        let past = Array.isArray(server_past_slots) ? server_past_slots : [];
        let cleared = 0;
        services.forEach(serv => {
            // edit_flag rows are an in-progress reschedule; the cart already clears their
            // times on load, and the server rejects a past reschedule.
            if (serv && !serv.edit_flag && serv.slot_start_time && (is_expired(serv) || matches_any(serv, past))) {
                clear_slot(serv);
                cleared++;
            }
        });
        if (cleared) {
            session.set('service_obj', JSON.stringify(services));
            session.set(EXPIRED_NOTICE_KEY, 1);
        }
        return cleared;
    },

    // Availability results come back in completion order (server async.each) and may cover
    // only part of the cart, so each submitted slot carries its cart position, which the
    // server echoes back. Never map results to the cart by response index.
    with_cart_index(serv, cart_index) {
        return Object.assign({}, serv, { cart_index: cart_index });
    },

    unavailable_cart_indexes(results) {
        return (Array.isArray(results) ? results : [])
            .filter(result => result && result.is_available == 0 && Number.isInteger(result.cart_index))
            .map(result => result.cart_index);
    },

    is_slot_in_past_error(error) {
        return !!(error && error.response && error.response.data && error.response.data.code === 'SLOT_IN_PAST');
    },
};
